import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { RxCross1 } from "react-icons/rx";
import ChoseMembers from "../ChoseMembers";
import SelectedUser from "../SelectedUser";
import { MdOutlineCheckBox } from "react-icons/md";
import { BsCheck2Square } from "react-icons/bs";
import InputField from "../InputField";
function AddFolderModal(props) {
  const formik = props?.formik;

  const SelectedColor = ({ color }) => {
    // console.log(formik?.values, formik.errors, color);
    return formik.values.color === color ? <BsCheck2Square /> : null;
  };

  const ListOfColor = ({ className, color }) => {
    return (
      <li
        className={className}
        onClick={() => formik.setFieldValue("color", color)}
      >
        <SelectedColor color={color} />
      </li>
    );
  };
  return (
    <Modal
      isOpen={props?.addFolderModal}
      toggle={props?.addFoldertoggle}
      size="md"
      centered
    >
      <ModalHeader toggle={props?.addFoldertoggle}>
        {props?.title}
      </ModalHeader>
      <ModalBody>
        <form className="formWrap">
          <div
            className="formSelectWrap"
            style={{ marginBottom: "15px" }}
          >
            <InputField
              formik={formik}
              id={"name"}
              name={"name"}
              placeholder={"Folder Name"}
              type={"text"}
              touch={formik.touched.name}
              error={formik.errors.name}
              value={formik.values.name}
            />
          </div>
          {props?.isEdit ? null : (
            <>
              <ChoseMembers
                onSelect={(user) => props?.handleSelectUsers(user)}
              />
              <SelectedUser
                onRemove={(user) => props?.removeSelectUsers(user)}
                selectedUsers={props?.selectedUsers}
              />
            </>
          )}

          <div
            className="formSelectWrap"
            style={{ marginBottom: "15px" }}
          >
            <InputField
              formik={formik}
              id={"description"}
              name={"description"}
              placeholder={"Keynote"}
              type={"textarea"}
              touch={formik.touched.description}
              error={formik.errors.description}
              value={formik.values.description}
              rows={7}
            />
          </div>
          <div className="colorPanel">
            <div className="colorTitle">
              <h4>Add Label Color</h4>
              <span
                className="removeColor"
                onClick={() => formik.setFieldValue("color", "")}
              >
                Remove Color
              </span>
              <ul className="colorList">
                {/* <li className="blank">
                  <RxCross1 />
                </li>
                <li className="color1 "></li> */}
                <ListOfColor className={"color2"} color={"#857ACF"} />
                <ListOfColor className={"color3"} color={"#72ACE8"} />
                <ListOfColor className={"color4"} color={"#A8DEF8"} />
                <ListOfColor className={"color5"} color={"#D1F4DE"} />
                <ListOfColor className={"color6"} color={"#FCF6BC"} />
                <ListOfColor className={"color7"} color={"#FF99C8"} />
                <ListOfColor className={"color8"} color={"#E4C1F9"} />
                <ListOfColor className={"color9"} color={"#ED7E90"} />
                <ListOfColor
                  className={"color10"}
                  color={"#ED987E"}
                />
                <ListOfColor
                  className={"color11"}
                  color={"#EBD199"}
                />
              </ul>
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={formik.handleSubmit}>
          {props?.isEdit ? "Update" : "Create"}
        </Button>
        <Button color="outline" onClick={props?.addFoldertoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default AddFolderModal;
